import * as actions from './membership.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { MembershipModel } from '@smarttask-common/src/lib/models/Membership/Core/MembershipModel';

export const membershipAdapter = createEntityAdapter<MembershipModel>({
    selectId: (x) => x.membership_id,
});
export interface MembershipState extends EntityState<MembershipModel> {
    selected_membership_id: string;
}

export const initialState: MembershipState = membershipAdapter.getInitialState({
    selected_membership_id: undefined,
});

export function MembershipReducers(state: MembershipState = initialState, action: actions.MembershipActions) {
    switch (action.type) {
        case actions.MembershipActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_membership_id: action.selected_membership_id };
            //console.log(state);
            return state;

        case actions.MembershipActionTypes.ADD_MEMBER:
            return membershipAdapter.addOne(action.member, state);

        case actions.MembershipActionTypes.ADD_MEMBERS:
            return membershipAdapter.addMany(action.members, state);

        case actions.MembershipActionTypes.UPSERT_MEMBER:
            return membershipAdapter.upsertOne(action.member, state);

        case actions.MembershipActionTypes.UPSERT_MEMBERS:
            return membershipAdapter.upsertMany(action.members, state);

        case actions.MembershipActionTypes.UPDATE_MEMBER:
            return membershipAdapter.updateOne(action.member, state);

        case actions.MembershipActionTypes.UPDATE_MEMBERS:
            return membershipAdapter.updateMany(action.members, state);

        case actions.MembershipActionTypes.DELETE_MEMBER:
            return membershipAdapter.removeOne(action.membership_id, state);

        case actions.MembershipActionTypes.DELETE_MEMBERS:
            return membershipAdapter.removeMany(action.membership_ids, state);

        case actions.MembershipActionTypes.DELETE_ALL_MEMBERS:
            return membershipAdapter.removeMany(action.membership_ids, state);

        case actions.MembershipActionTypes.DELETE_ALL:
            return membershipAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getMembershipState = createFeatureSelector<MembershipState>('membership');

export const { selectIds, selectEntities, selectAll, selectTotal } = membershipAdapter.getSelectors(getMembershipState);

const getSelectedMemberIdState = (state: MembershipState) => {
    return state.selected_membership_id;
};
export const getSelectedMemberId = createSelector(getMembershipState, getSelectedMemberIdState);

export const getSelectedMember = createSelector(getMembershipState, (state: MembershipState) => {
    if (state.selected_membership_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_membership_id];
});
